import React from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

export const FormActions = ({ onSave, onSubmit, isSubmitting, t }) => (
  <Box sx={{ mt: 5 }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.75,
        mb: 3,
        px: 2,
      }}
    >
      <LockOutlinedIcon sx={{ color: "#9ca3af", fontSize: 14, flexShrink: 0 }} />
      <Typography variant="caption" sx={{ color: "#9ca3af", textAlign: "center", lineHeight: 1.5 }}>
        {t.submitInstructions}
      </Typography>
    </Box>

    <Box
      sx={{
        display: "flex",
        gap: 2,
        justifyContent: "center",
        flexDirection: { xs: "column", sm: "row" },
      }}
    >
      <Button
        variant="outlined"
        onClick={onSave}
        disabled={isSubmitting}
        sx={{
          minWidth: { xs: "100%", sm: 180 },
          py: 1.5,
          fontSize: "0.95rem",
          fontWeight: 600,
          borderWidth: 2,
          borderRadius: 2,
          borderColor: "#163666",
          color: "#163666",
          "&:hover": { borderWidth: 2, borderColor: "#163666", backgroundColor: "rgba(159,180,206,0.15)" },
        }}
      >
        {t.save}
      </Button>
      <Button
        variant="contained"
        onClick={onSubmit}
        disabled={isSubmitting}
        sx={{
          minWidth: { xs: "100%", sm: 200 },
          py: 1.5,
          fontSize: "0.95rem",
          fontWeight: 700,
          borderRadius: 2,
          background: "linear-gradient(135deg, #163666 0%, #32639d 100%)",
          boxShadow: "0 4px 14px rgba(22,54,102,0.4)",
          letterSpacing: "0.02em",
          "&:hover": {
            background: "linear-gradient(135deg, #102a52 0%, #163666 100%)",
            boxShadow: "0 6px 18px rgba(22,54,102,0.5)",
          },
        }}
      >
        {isSubmitting
          ? <CircularProgress size={22} sx={{ color: "#fff" }} />
          : <span>{t.submit}</span>}
      </Button>
    </Box>
  </Box>
);
